import NeedDetailDialog, {
  NeedDetailUniqueProps,
} from 'react-components/needs/need-detail-dialog/need-detail-dialog';
import { getDialogHooks } from 'utilities/dialog-context/dialog-context-helpers';

const { useDialogForContext, useDialog: useNeedDetailDialog } = getDialogHooks<
  NeedDetailUniqueProps,
  void
>(NeedDetailDialog);
export const useNeedDetailDialogForContext = useDialogForContext;
export default useNeedDetailDialog;
